import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import { accountRestricted, reportSpeedSupport } from "./messages";
import { useDispatch, useSelector } from "react-redux";
import { setAccountRestrictedModalData } from "../redux/actions";
import { useNavigate } from "react-router-dom";
import InvalidErrorModal from "./InvalidErrorModal";

function AccountRestrictedModal({ isFromBrowser }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const redirectionPathToPermission = "/settings/advance-settings/permission";

  const [isOpenModal, setIsOpenModal] = useState(false);
  const accountRestrictedModalData = useSelector(
    (state) => state.common.accountRestrictedModalData
  );

  const { errorMessage, callbackErrorFn, openRestrictedModal } = {
    ...accountRestrictedModalData,
  };

  useEffect(() => {
    if (Object.keys(accountRestrictedModalData)?.length > 0) {
      setIsOpenModal(openRestrictedModal);
    } else {
      setIsOpenModal(false);
    }
  }, [accountRestrictedModalData]);

  const handleModalClose = () => {
    dispatch(
      setAccountRestrictedModalData({
        openRestrictedModal: false,
      })
    );
    callbackErrorFn?.();
  };

  const handleRedirect = () => {
    handleModalClose();
    navigate(redirectionPathToPermission);
  };

  return (
    <Box>
      {isOpenModal && (
        <InvalidErrorModal
          isFromBrowser={isFromBrowser}
          isOpenInvalidQRModal={isOpenModal}
          setIsOpenInvalidQRModal={setIsOpenModal}
          handleModalClose={() => handleModalClose()}
          icon="invalid"
          message={accountRestricted}
          subMessage={errorMessage}
          direction={"up"}
          closeSendModal={accountRestrictedModalData?.openRestrictedModal}
          customClass={isFromBrowser ? "error-modal-wrapper-options" : ""}
          redirectToAccountStatus={true}
          handleButtonAction={handleModalClose}
          handleRedirectionToAccountStatus={handleRedirect}
        />
      )}
    </Box>
  );
}

export default AccountRestrictedModal;
